module.exports = __webpack_public_path__ + "assets/img/kornati.a28d40d0.png";